<template>
  <div class="china-shipppers">
    <!-- <shippers-head @shippers-empty="empty"></shippers-head> -->
    <div class="china-shipppers_box marTop20">
      <shippers-box
        v-for="(item, index) in shippersData"
        v-show="item.isSupported"
        :key="index"
        :shippers-data="item"
        @shippers-close="close">
      </shippers-box>
    </div>
  </div>
</template>

<script>
// import shippersHead from 'components/shippers/shippersHead.vue'
import shippersBox from './shippersBox.vue'
export default {
  data () {
    return {

    }
  },
  components: {
    // shippersHead,
    shippersBox
  },
  props: {
    shippersData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  mounted () {

  },
  methods: {
    close () {
      this.$emit('shippers-close')
    },
    empty () {
      this.$emit('shippers-empty')
    }
  }
}
</script>

<style scoped>
  .china-shipppers_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    max-height: 310px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shippers/chinaShippers.vue